import Vue from "vue"
import VueRouter from "vue-router"
import Home from "../views/Home.vue"
import Root from "./Root"
import i18n, { loadLocaleMessagesAsync } from "@/i18n"
import {
    setDocumentDirectionPerLocale,
    setDocumentLang,
    setDocumentTitle
} from "@/util/i18n/document"

Vue.use(VueRouter)

//const { locale } = i18n

const routes = [
    {
        path: "/:locale",
        component: Root,
        children: [
            {
                path: "",
                name: "home",
                component: Home
            },
        ]
    },
    {
        path: "/",
        component: Home,
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {

    to.params.locale = to.params.locale || process.env.VUE_APP_I18N_LOCALE || "he"

    /* eslint-disable no-console */
    console.log(to.params);
    /* eslint-enable no-console */
    if (to.params.locale === from.params.locale) {
        next()
        return
    }

    const { locale } = to.params

    loadLocaleMessagesAsync(locale).then(() => {
        setDocumentLang(locale)
        setDocumentDirectionPerLocale(locale)
        setDocumentTitle(i18n.t("app.title"))
    })

    next()
})

export default router